<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-btn size="default" color="default" flat fab icon="mdi-arrow-left" class="back-button"
            @click="$router.back()"></v-btn>
        <v-row justify="start" class="mt-3">
            <!-- Left Column (Retailer List) -->
            <v-col cols="12" md="4" class="d-flex flex-column" order="1" order-md="0">
                <div class="d-flex align-center">
                    <h3>RETAILERS</h3>
                </div>
                <v-divider></v-divider>
                <v-container class="flex-grow-1 d-flex flex-column px-0" style="height: 100%;">
                    <v-list active-class="shop-active" bg-color="transparent" class="flex-grow-1"
                        style="max-height: 650px; overflow-y: auto;" @update:selected="shopSelected">
                        <v-list-item class="map-search-entry bg-white pa-1" :value="item" :ripple="false"
                            v-for="(item, index) in retailers" :key="index">
                            <v-row align="center">
                                <v-col cols="4" sm="2" md="2" lg="2" align="center">
                                    <v-avatar tile icon="mdi-home-outline" size="64"></v-avatar>
                                </v-col>
                                <v-col cols="8" sm="10" md="10" lg="10">
                                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item.address.street }} ,{{ item.address.city
                                        }}</v-list-item-subtitle>
                                </v-col>
                            </v-row>
                        </v-list-item>
                    </v-list>
                </v-container>
            </v-col>

            <!-- Right Column (Map - Fixed Height 500px) -->
            <v-col cols="12" md="8" order="0" order-md="1">
                <v-container style="height: 750px;" class="mt-3 mt-md-0">
                    <l-map ref="mapRef" :zoom="zoom" :center="center" style="height: 100%; width: 100%;"
                        class="retailers-map">
                        <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; OpenStreetMap contributors"></l-tile-layer>
                        <l-marker :lat-lng="[item.location?.latitude, item.location?.longitude]"
                            v-for="item in retailers" :key="item.id" ref="markerRefs">
                            <l-icon :icon-anchor="staticAnchor" :icon-size="['40', '40']" class-name="someExtraClass"
                                :icon-url="`/images/mapicons/map-icon-${item.productCategories?.[0]?.identifier ?? 'store'}.png`">
                            </l-icon>
                            <l-popup>
                                <v-list-item width="200px" class="pa-0">
                                    <v-row align="center">
                                        <v-col md="12" lg="12">
                                            <v-list-item-title>{{ item?.name }}</v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ item?.address.street }}
                                                {{ item?.address.postcode }} {{ item?.address.city }}
                                            </v-list-item-subtitle>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                            </l-popup>
                        </l-marker>
                    </l-map>
                </v-container>
            </v-col>
        </v-row>





        <CustomTopSheetDialog v-model="showSheet" :width="600"
            :title="`Video ${currentCompany != null ? currentCompany.name : ''}`">
            <div class="video-wrapper">
                <iframe :src="`${$vimeoUrl}${currentCompany.vimeoLink}`" frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </CustomTopSheetDialog>
    </v-container>
</template>

<script>
import { ref, inject, nextTick, watch, getCurrentInstance, onMounted } from 'vue';
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPopup, LIcon, LControlAttribution } from "@vue-leaflet/vue-leaflet";
import L from "leaflet";
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import { useRoute, useRouter } from 'vue-router'

export default {
    components: {
        CustomTopSheetDialog,
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LIcon,
    },
    setup() {
        // const showSheet = ref(false);
        const mapRef = ref(null);
        const route = useRoute()
        const router = useRouter()
        const { proxy } = getCurrentInstance()
        const config = {
            itemsToShow: 3
        }
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const openText = ref(false);
        const toggleText = () => {
            openText.value = !openText.value; // Toggle the open state
        }
        const markerRefs = ref([]);
        const center = ref([0, 0])
        const zoom = ref(1);
        const retailers = ref([]);

        const openDiscoverPopup = inject('openDiscoverPopup');

        const triggerOpenDiscoverPopup = (label) => {
            openDiscoverPopup(label);
        }

        const shopSelected = async (event) => {
            if (event.length == 0) {
                center.value = [0, 0];
                zoom.value = 1;
                // selectedShop.value = null;
                return;
            } else {
                const shop = event[0];
                // selectedShop.value = shop;
                zoom.value = 20;
                center.value = [shop.location.latitude, shop.location.longitude];

                await nextTick();

                const marker = markerRefs.value.find(
                    (m) => m?.leafletObject && m.$.vnode.key === shop.id
                );

                if (marker?.leafletObject) {
                    marker.leafletObject.openPopup(); // Opens the popup programmatically
                } else {
                    console.warn("Marker not found for shop:", shop);
                }
            }
        }

        const fetchMerchantStreams = async () => {
            try {
                const hardToken = localStorage.getItem("hardToken");
                const username = localStorage.getItem("username");
                const response = await proxy.$axios.get(`/merchant/${route.params.merchantId}/shops`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-USER': username
                    }
                });
                retailers.value = response.data.data;
            } catch (error) {
                if (error.response?.status === 401 || error.response?.status === 403) {
                    console.log("Session expired or unauthorized. Redirecting.");
                    router.replace("/login");
                } else if (error.response?.status === 500) {
                    router.push("/404");
                }
            }
        };


        const openContactDialog = inject('openContactDialog')

        const triggerOpenContactDialog = (merchant) => {
            openContactDialog(merchant);
        }


        watch(
            retailers,
            (newRetailers) => {
                if (newRetailers.length > 0) {
                    nextTick(() => {
                        const map = mapRef.value?.leafletObject;
                        if (!map) return;

                        const bounds = L.latLngBounds(
                            newRetailers
                                .filter(item => item.location?.latitude && item.location?.longitude)
                                .map(item => [item.location.latitude, item.location.longitude])
                        );

                        if (bounds.isValid()) {
                            map.fitBounds(bounds, {
                                padding: [40, 40],
                                maxZoom: 16
                            });
                        }
                    });
                }
            },
            { immediate: true }
        );
        
        onMounted(() => {
            fetchMerchantStreams();
        });
        return {
            // showSheet:false,
            config,
            openText,
            toggleText,
            route,
            selectedLanguage,
            triggerOpenContactDialog,
            triggerOpenDiscoverPopup,
            center,
            zoom,
            shopSelected,
            markerRefs,
            retailers,
            mapRef,
            fetchMerchantStreams
        };
    },

    data() {
        return {
            currentCompany: {},
            htmlContent: "<strong>Hello, World!</strong> This is <em>raw HTML</em>.",
            showSheet: false,
            items: [
                "Kundenmagnet",
                "Image Booster",
                "Must-Have",
                "Geheimtipp",
                "Margen-Held",
                "PR-Star",
                "Kundenliebling",
                "Durchstarter",
            ],
            images: [
                "https://picsum.photos/200/300", "https://picsum.photos/300/300", "https://picsum.photos/500/300"
            ]
        }
    },

    mounted() {
        // this.fetchMerchantStreams();
    },

    methods: {
        // fetchMerchantStreams() {
        //     const hardToken = localStorage.getItem("hardToken");
        //     const username = localStorage.getItem("username");
        //     var _this = this;
        //     this.$axios.get("/merchant/" + this.route.params.merchantId + "/shops", {
        //         headers: {
        //             'X-Auth-HARDTOKEN': hardToken,
        //             'X-Auth-USER': username
        //         },
        //     })
        //         .then(this.merchantStreamsFetched)
        //         .catch(error => {

        //             // You can handle specific error codes here, for example, a 401 Unauthorized
        //             if (error.response && error.response.status === 401 || error.response.status === 403) {
        //                 // Handle token expiration or unauthorized error
        //                 console.log("Session expired or unauthorized. Please log in again.");
        //                 _this.$router.replace('/login');
        //                 // Optionally log the user out or redirect to login page
        //             } else if (error.response && error.response.status === 500) {
        //                 _this.$router.push('/404')
        //             }
        //         });

        // },
        // merchantStreamsFetched(response) {
        //     this.retailers = response.data.data;
        // }
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
}

.description-wrapper {
    position: relative;
}


a {
    text-decoration: none;
}

.description-text {
    display: block;
    max-height: 200px;
    /* Adjust the height based on your design */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    transition: max-height 0.3s ease-in-out;
    font-size: 14px;
}

.map-shop-list {
    overflow-y: scroll;
}

.description-text.truncated {
    max-height: 200px;
    /* Limit text height when truncated */
}

.description-text:not(.truncated) {
    max-height: none;
    /* Allow full text to show when toggled */
}

.text-link {
    text-decoration: none;
    color: #1e88e5;
    cursor: pointer;
    float: right;
}

.text-link:hover {
    text-decoration: underline;
}

@media only screen and (max-width: 960px) {
    .back-button {
        position: absolute;
        left: 24px !important;
    }

    .back-button .v-icon {
        width: 20px !important;
        height: 20px !important;
        min-width: none;
        min-height: none;
    }
}

.back-button {
    position: absolute;
    left: 250px;
}

.back-button .v-icon {
    width: 20px !important;
    height: 20px !important;
    min-width: none;
    min-height: none;
}
</style>

<style>
/*.dialog-list-item {
    min-height: 30px !important;
    background-color: transparent !important;
  }
  
  */
.colored-chip {
    color: white !important;
}

.retailers-map .leaflet-popup-content-wrapper {
    border-radius: 0px !important;
}

.video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 ratio */
    height: 0;
    overflow: hidden;
}

.video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}



.share-hint,
.descrption-text {
    font-size: 14px !important;
}

h1 {
    font-size: 36px !important;
    ;
}

h4 {
    font-size: 16px !important;
    font-weight: 700;
}

.f-16 {
    font-size: 16px !important;
}

.edit-btn {
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 1;
}

.logo-sheet {
    background-image: url('https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/6cc5fce5-d423-4af3-8bf8-e5d25a234e80/AVATAR');
    background-size: cover;
}
</style>